var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKulcsUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 282,
    viewBox: "0 0 580 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9430_130016)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 282,
    rx: 24,
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M596.312 93.4651C547.551 171.201 404.15 292.922 220.637 157.916C88.3779 60.6163 5.73179 100.776 -38 161.38",
    stroke: "url(#paint0_linear_9430_130016)",
    strokeWidth: 1.69605,
    strokeDasharray: "8.48 8.48"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.45,
    y: 57,
    width: 60.5918,
    height: 60.5918,
    rx: 15.1597,
    fill: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.833 81.7481H345.329V80.2351C345.329 77.4497 343.071 75.1917 340.285 75.1917C337.5 75.1917 335.242 77.4497 335.242 80.2351V81.7481C334.128 81.7481 333.225 82.6513 333.225 83.7655V87.89C333.225 87.9694 333.262 88.0441 333.325 88.0918C334.255 88.7572 335.012 89.6357 335.531 90.6538C335.575 90.7384 335.661 90.7918 335.756 90.792H341.727C343.329 90.7672 344.674 91.9903 344.802 93.5871C344.811 93.7191 344.921 93.8214 345.053 93.8211H345.833C346.947 93.8211 347.851 92.9179 347.851 91.8037V83.7655C347.851 82.6513 346.947 81.7481 345.833 81.7481ZM337.259 80.2351C337.259 78.5638 338.614 77.209 340.285 77.209C341.957 77.209 343.311 78.5638 343.311 80.2351V81.4959C343.311 81.6352 343.199 81.7481 343.059 81.7481H337.512C337.372 81.7481 337.259 81.6352 337.259 81.4959V80.2351ZM341.294 88.7806V87.5621C341.887 87.2197 342.176 86.5217 341.999 85.8602C341.822 85.1987 341.223 84.7388 340.538 84.7388C339.853 84.7388 339.254 85.1987 339.076 85.8602C338.899 86.5217 339.188 87.2197 339.781 87.5621V88.7806C339.781 89.1984 340.12 89.5371 340.538 89.5371C340.956 89.5371 341.294 89.1984 341.294 88.7806Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.732 92.3063C342.56 92.2941 343.253 92.9308 343.312 93.7568C343.33 94.1707 343.18 94.5743 342.894 94.8744C342.608 95.1745 342.213 95.345 341.798 95.3465L340.665 97.1601C340.571 97.3105 340.404 97.4004 340.227 97.3969C340.05 97.3934 339.887 97.297 339.799 97.143L338.846 95.4756C338.8 95.3967 338.715 95.3483 338.624 95.3485H338.405C338.32 95.3489 338.24 95.393 338.194 95.4655L337.124 97.1742C337.03 97.3247 336.863 97.4143 336.685 97.4099C336.507 97.4056 336.345 97.308 336.258 97.1531L335.315 95.4797C335.27 95.3998 335.185 95.3506 335.094 95.3516H334.579C333.907 97.7445 331.726 99.3984 329.24 99.3994H329.214C327.734 99.3992 326.314 98.8098 325.269 97.7614C324.223 96.713 323.638 95.2918 323.642 93.8113C323.685 90.9502 325.861 88.5732 328.707 88.2776C328.88 88.2615 329.054 88.2534 329.224 88.2534C331.709 88.2658 333.887 89.9172 334.57 92.3063H341.732ZM326.92 93.825C326.92 94.5214 327.485 95.0859 328.181 95.0859C328.516 95.0859 328.836 94.9531 329.073 94.7166C329.309 94.4801 329.442 94.1594 329.442 93.825C329.442 93.1287 328.878 92.5642 328.181 92.5642C327.485 92.5642 326.92 93.1287 326.92 93.825Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.679,
    y: 179.964,
    width: 44.0362,
    height: 44.0362,
    rx: 11.6349,
    fill: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9430_130016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.033 201.982L464.425 205.374L470.785 199.014",
    stroke: "#48A0FF",
    strokeWidth: 2.54408,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 99,
    width: 87.2612,
    height: 87.2612,
    rx: 21.905,
    fill: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M164.629 142.269C169.02 142.269 172.579 138.71 172.579 134.32C172.579 129.929 169.02 126.37 164.629 126.37C160.239 126.37 156.68 129.929 156.68 134.32C156.68 138.71 160.239 142.269 164.629 142.269Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.63 144.437C157.05 144.446 150.908 150.589 150.899 158.168C150.899 158.568 151.222 158.891 151.622 158.891H177.638C178.038 158.891 178.361 158.568 178.361 158.168C178.352 150.589 172.21 144.446 164.63 144.437Z",
    fill: "#007AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9430_130016",
    x: 457.641,
    y: 193.926,
    width: 16.1123,
    height: 17.1125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.956863 0 0 0 0 0.960784 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9430_130016"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9430_130016",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9430_130016",
    x1: -38,
    y1: 155.992,
    x2: 596.312,
    y2: 155.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#007AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004999"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9430_130016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 580,
    height: 282,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKulcsUser);
export default __webpack_public_path__ + "static/media/kulcs-user.09a8afa1395c5771f63983a163dfa293.svg";
export { ForwardRef as ReactComponent };